import { useRootStore } from '@pinia/index';
import { useSessionStore } from '@pinia/session';

export default () => {
  const root = useRootStore();
  const sessionStore = useSessionStore();

  const executeApiCall: typeof root.authService.executeApiCall = (method, requestMessage) => {
    const metadata = new Headers();
    if (sessionStore.token != null) {
      metadata.set('Authorization', `Bearer ${sessionStore.token}`);
    }
    return root.authService.executeApiCall(method, requestMessage, metadata);
  };

  return {
    executeApiCall,
    client: null,
  };
};
